if(!global["HG"]) global["HG"] = {};
module.exports = global["HG"]["EventTracking"] = require("-!/Users/kennethyoung/Projects/hipages/hip-assets/node_modules/exports-loader/index.js?HG.EventTracking!/Users/kennethyoung/Projects/hipages/hip-assets/node_modules/babel-loader/lib/index.js??ref--0-0!./HG.EventTracking.js");


//////////////////
// WEBPACK FOOTER
// ../node_modules/expose-loader?HG.EventTracking!../node_modules/exports-loader?HG.EventTracking!../legacy/src/js/HG.EventTracking.js
// module id = 50
// module chunks = 1